import { jsx as _jsx } from "react/jsx-runtime";
// /**
//  * JoyrideTooltip class
//  * @class JoyrideTooltip
//  */
import { useRef } from 'react';
import styled from 'styled-components';
import { v4 as uuid } from 'uuid';
import { Colors, transparentize } from '../../../Constants/Colors';
import Tooltip from '../../../Components/Interactive/Tooltip/Tooltip';
import { Scheme } from '../../../Constants/System';
const defaultProps = {
    scheme: Scheme.info,
    animation: 'shift-toward',
    placement: 'left',
    delay: [50, 0],
    offset: [0, 50],
    duration: [250, 250],
    sticky: true,
};
export default function JoyridePrompt(props) {
    /** HTML component that displays step progress */
    let stepTracker = null;
    // Construct step tracker
    if (props.showStepTracker && props._totalSteps && props._currentStepNumber !== undefined) {
        const steps = [];
        let i = 0;
        while (i < props._totalSteps) {
            steps.push(_jsx("div", { className: `step-item ${i <= props._currentStepNumber ? 'active' : ''}` }, uuid()));
            i++;
        }
        stepTracker = _jsx("div", { className: "step-tracker-container", children: steps });
    }
    /** All buttons needed for prompt */
    const actions = [];
    // Show finish button, or skip and/or next button
    if (props._totalSteps &&
        props._currentStepNumber === props._totalSteps - 1 &&
        (props.showNextButton || props.showSkipButton)) {
        actions.push({
            children: 'Finish',
            onClick: () => props._callbacks?.nextCallback?.(),
            className: 'trigger-joyride-step',
        });
    }
    else {
        if (props.showSkipButton) {
            actions.push({
                children: 'Skip',
                onClick: () => props._callbacks?.skipCallback?.(),
                className: 'skip-joyride',
            });
        }
        if (props.showNextButton) {
            actions.push({
                children: 'Next',
                onClick: () => props._callbacks?.nextCallback?.(),
                className: 'trigger-joyride-step',
            });
        }
    }
    const ContainerRef = useRef(null);
    const mergedProps = {
        ...defaultProps,
        ...props,
    };
    delete mergedProps.target;
    delete mergedProps.showStepTracker;
    delete mergedProps.showNextButton;
    delete mergedProps.showSkipButton;
    delete mergedProps._target;
    delete mergedProps._totalSteps;
    delete mergedProps._currentStepNumber;
    delete mergedProps._callbacks;
    return (_jsx(TooltipContainer, { ref: ContainerRef, children: _jsx(Tooltip, { ...mergedProps, body: stepTracker, actions: actions, reference: props._target, appendTo: ContainerRef.current }) }));
}
const TooltipContainer = styled.div `
	.skip-joyride {
		border: none;
		background: transparent;
		color: inherit;

		&:hover {
			background: #4a4a4a40;
		}
	}

	.trigger-joyride-step {
		border: none;
		background: #4a4a4a60;
		color: inherit;

		&:hover {
			background: #4a4a4aa6;
		}
	}

	.step-tracker-container {
		display: flex;
		flex-direction: row;
		gap: 12px;
		align-items: center;
		justify-content: center;
		position: absolute;
		bottom: -${(props) => props.theme.sizing.xs};

		.step-item {
			border-radius: 50%;
			overflow: hidden;
			background: ${transparentize(Colors.white, 0.8)};
			height: 12px;
			width: 12px;

			&.active {
				background: ${transparentize(Colors.yellow, 0.2)};
				box-shadow: 0px 0px 10px ${transparentize(Colors.yellow, 0.7)};
			}
		}
	}
`;
//# sourceMappingURL=JoyridePrompt.js.map